<template>
<div>
  <div class="footer_perm__box">
    <div class="footer_box__flex_left">
      <form>
        <select style="width: 136px;">
          <optgroup label="Выбор стиля">
            <option>IPB Default Skin</option>
          </optgroup>
        </select>
      </form>
      <span v-html="nbsp"></span>
      <form>
        <select style="width: 86px;">
          <optgroup label="Язык">
            <option>Russian</option>
          </optgroup>
        </select>
      </form>
    </div>
    <div class="footer_box__flex_center"><a><b>Упрощенная версия</b></a></div>
    <div class="footer_box__flex_right">
      <img src="../assets/stat_time.gif"> {{loadTime}}(q0.000) sec <span v-html="nbsp"></span><span v-html="nbsp"></span>
      <img src="../assets/stat_load.gif"> -- <span v-html="nbsp"></span><span v-html="nbsp"></span>
      <img src="../assets/stat_sql.gif"> {{totalRequests}} <span v-if="totalRequests != 1">queries</span><span v-else>query</span> <span v-html="nbsp"></span><span v-html="nbsp"></span>
      <img src="../assets/stat_gzip.gif"> GZIP включён
      <br>
      Сейчас: 15 October 2006, {{getCurrentTime()}}</div>
  </div>
  <div class="footer_perm__contact">
    Contact: <a>hello@rpgplanet.ru</a><br />
  </div>
</div>
</template>

<script>
export default {
  props: ['loadTime', 'totalRequests'], // now use {{loadTime}}
  methods: {
    getCurrentTime() {
      let today = new Date();
      let time = today.getHours() + ":" + today.getMinutes();
      return time;
    }
  }
}
</script>

<style lang="scss">
.footer_perm__contact {
    text-align: center;
    font-size: 10px;
}
.footer_perm__box {
    background: #243F4D;
    height: 40px;
    border: 1px solid #000;
    margin-bottom: 5px;
    margin-top: 6px;
    a {
        color: #fff;
    }
    font-size: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .footer_box__flex_left {
        width: 100%;
        padding: 4px;
    }
    .footer_box__flex_right {
        width: 100%;
        text-align: right;
        padding: 5px 4px 4px;
        img {
            vertical-align: middle;
        }
        line-height: 130%;
    }
    .footer_box__flex_center {
        width: 10%;
        text-align: center;
        white-space: nowrap;
    }
    form {
        display: inline;
    }
    optgroup,
    option,
    select {
        font-size: 11px;
        background-color: #374858;
        color: #fff;
        height: 22px;
        padding: 0 0 6px;
        //border: 2px solid #546971;
        font-family: verdana, helvetica, sans-serif;
    }

    // for a firefox bug, otherwise this style can be removed
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1421373
    optgroup {
        background-color: #374857;
    }
}
</style>
